import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-obsidian text-white" data-id="element-89" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" style={{
      paddingTop: "22px",
      paddingBottom: "15px"
    }} data-id="element-90" data-mp="3ghc4m7ro7dqv">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-aqua" data-id="element-91" data-mp="36pfufycb7x6a">SIGMA SMART™</p>
        <p className="mt-3 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-92" data-mp="3uf0obca04euc">
          UZUN MESAFE TRİATLON SİSTEMİ™
        </p>
        <p className="mt-3 text-sm font-semibold uppercase tracking-wider text-white/70" data-id="element-93" data-mp="37o7wzgy05fh">
          Daha akıllı antrenman yap. Daha iyi beslen. Yarışa güvenle hazırlan.
        </p>
        <p className="mt-2 text-sm text-white/50" data-id="element-94" data-mp="3qcx9cdo4is4b">
          Antrenmandan bitiş çizgisine kadar tüm hazırlık sürecinizi tek bir sistem içerisinde organize edin.
        </p>

        <a href="mailto:soporte.sigmasmart@gmail.com" className="mt-8 inline-flex items-center gap-2 text-sm text-white/75 transition-colors duration-150 ease-out hover:text-white" data-id="element-95" data-mp="2ey9zrxfcyroe">
          <MailIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-96" data-mp="3lbmu7sfd78fw" /> Destek: soporte.sigmasmart@gmail.com
        </a>

        <nav aria-label="Yasal" className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/45" data-id="element-97" data-mp="3v7gejxzbs688">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-98" data-mp="3q8dkf8kvvkf1">Kullanım Koşulları</a>
          <span aria-hidden="true" data-id="element-99" data-mp="81yx4j0q5y3z">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-100" data-mp="80xmugrj9fnb">Gizlilik Politikası</a>
          <span aria-hidden="true" data-id="element-101" data-mp="hsttwhblkg3o">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-102" data-mp="hrs75fl7y564">Destek</a>
        </nav>

        <p className="mt-8 text-xs text-white/35" data-id="element-103" data-mp="cu8uul8302gt">© 2026 SIGMA SMART™ — Tüm Hakları Saklıdır.</p>
      </div>
    </footer>;
}